"use strict";
window['Raphael'] = require('raphael');
require('justgage');
var core_1 = require('@angular/core');
var justgage_component_1 = require('./justgage.component');
var JustgageModule = (function () {
    function JustgageModule() {
    }
    JustgageModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [justgage_component_1.JustgageComponent],
                    exports: [justgage_component_1.JustgageComponent]
                },] },
    ];
    /** @nocollapse */
    JustgageModule.ctorParameters = [];
    return JustgageModule;
}());
exports.JustgageModule = JustgageModule;
//# sourceMappingURL=justgage.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-justgage/dist/justgage.module.js
// module id = 1448
// module chunks = 3